import React, { useState } from 'react';
import { toast } from 'sonner';
import { adminApi, apiError } from '../../lib/adminApi';
import { FLAVOURS, FLAVOUR_ORDER } from '../../data/mock';
import { Sparkles, Loader2, Film } from 'lucide-react';

const sel = 'w-full bg-black border border-white/15 rounded-lg px-3 py-2.5 text-white text-sm outline-none focus:border-red-500';

export default function SocialGenerator({ onCreated }) {
  const [form, setForm] = useState({ flavour: 'strawberry', style: 'realistic', language: 'el', topic: '' });
  const [busy, setBusy] = useState('');
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const generate = async (video = false) => {
    setBusy(video ? 'video' : 'image');
    try {
      const { data } = await adminApi.post(video ? '/admin/social/video' : '/admin/social/generate', form);
      onCreated(data);
      toast.success(video ? 'Video in creazione: pronto in 3-8 minuti' : 'Creazione avviata: pronto in circa 30-60 secondi');
    } catch (e) { toast.error(apiError(e)); }
    setBusy('');
  };

  return (
    <div className="bg-[#0d0d0d] border border-white/10 rounded-xl p-5 space-y-4" data-testid="social-generator">
      <div className="flex items-center gap-2">
        <Sparkles className="text-red-500" size={18} />
        <h3 className="text-white font-bold">Crea post con AI</h3>
      </div>
      <div className="grid sm:grid-cols-3 gap-3">
        <select data-testid="gen-flavour" className={sel} value={form.flavour} onChange={set('flavour')}>
          {FLAVOUR_ORDER.map((f) => <option key={f} value={f}>{FLAVOURS[f].name}</option>)}
          <option value="mix">MIX BOX (6 gusti)</option>
        </select>
        <select data-testid="gen-style" className={sel} value={form.style} onChange={set('style')}>
          <option value="realistic">Realistico (foto prodotto)</option>
          <option value="graphic">Grafico (colori del gusto)</option>
        </select>
        <select data-testid="gen-language" className={sel} value={form.language} onChange={set('language')}>
          <option value="el">Greco</option>
          <option value="it">Italiano</option>
          <option value="en">Inglese</option>
        </select>
      </div>
      <input data-testid="gen-topic" className={sel} maxLength={400} value={form.topic} onChange={set('topic')}
        placeholder="Idea del post (opzionale): es. offerta estate, palestra, serata con amici…" />
      <div className="flex flex-wrap gap-3">
        <button data-testid="gen-submit" onClick={() => generate(false)} disabled={!!busy}
          className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-500 disabled:opacity-50 text-white font-bold text-sm px-5 py-2.5 rounded-lg transition-colors">
          {busy === 'image' ? <Loader2 size={16} className="animate-spin" /> : <Sparkles size={16} />} Genera testo + immagine
        </button>
        <button data-testid="gen-video-submit" onClick={() => generate(true)} disabled={!!busy}
          className="inline-flex items-center gap-2 border border-red-500 text-white hover:bg-red-600 disabled:opacity-50 font-bold text-sm px-5 py-2.5 rounded-lg transition-colors">
          {busy === 'video' ? <Loader2 size={16} className="animate-spin" /> : <Film size={16} />} Crea video Reel (8s, con audio)
        </button>
      </div>
    </div>
  );
}
